import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  private language = signal<string>('');

  constructor(private translateService: TranslateService) {}

  private checkSavedLang() {
    const locale = localStorage.getItem('locale');
    if (locale) {
      this.translateService.use(locale);
      this.language.set(locale);
    } else {
      this.setActiveLanguage(this.DefaultLanguage)
    }
  }

  init(langs?: string[]) {
    if (langs?.length) {
      this.translateService.addLangs(langs);
    }

    this.checkSavedLang();
  }

  get ActiveLanguage() {
    return this.language();
  }

  get DefaultLanguage() {
    return this.translateService.defaultLang;
  }

  setDefaultLang(language: string) {
    return this.translateService.setDefaultLang(language);
  }

  setActiveLanguage(language: string) {
    localStorage.setItem('locale', language);
    this.language.set(language);
    return this.translateService.use(language);
  }

  get AvailableLocales() {
    return this.translateService.getLangs();
  }

  set AvailableLocales(languages: string[]) {
    this.translateService.addLangs(languages);
  }
}
